import vert from './glsl/grassblade.vert.glsl';
import frag from './glsl/grassblade.frag.glsl';
export default { frag, vert };